import React, { Fragment, useEffect, useState } from "react";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import { Col, Form, Input, Row, Select, Space, Divider, Flex } from "antd";
import ButtonComponent from "@/components/button/Button";

import "@/styles/pages/profile/referee-details.scss";

import { countryList } from "@/helpers/countryList";
import BackWithLabel from "@/components/common/BackWithLabel";
import { updateReferee } from "@/services/users/updateReferee";
import { getRefereeDetails } from "@/services/users/getRefereeDetails";
import useTriggerNotification from "@/hooks/useTriggerNotification";
import { keyFilterOption } from "@/helpers";
import useUnsavedChanges from "@/hooks/useUnsavedChanges";

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 24, offset: 0 },
  },
};

const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: "red" }}>*</span>}
  </>
);

const filterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const relationshipOptions = [
  {
    value: "Parent",
    label: "Parent",
  },
  {
    value: "Spouse",
    label: "Spouse",
  },
  {
    value: "Sibling",
    label: "Sibling",
  },
  {
    value: "Child",
    label: "Child",
  },
  {
    value: "Guardian",
    label: "Guardian",
  },
  {
    value: "Relative",
    label: "Relative",
  },
  {
    value: "Friend",
    label: "Friend",
  },
];

const { Option } = Select;

const RefereeDetails = () => {
  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [form] = Form.useForm();
  const { trigger, element } = useTriggerNotification();

  const handleFinish = (value) => {
    updateReferee({
      name: value.name,
      mobileNumber: (value.countryCode ? value.countryCode : "+91") + " " + value.number,
      email: value.email,
      relation: value.relation,
      relationDuration: value.time,
      title: value.title,
      position: value.position,
      institutionName: value.institution,
      institutionAddress: value.address,
    })
      .then((res) => {
        console.log(res);
        trigger({
          type: "success",
          message: "Referee Details updated successfully",
        });
        setIsFormDisabled(true);
      })
      .catch((err) => console.log(err));
  };

  const fetchData = () => {
    getRefereeDetails()
      .then((res) => {
        const number = res.mobileNumber.split(" ");
        form.setFieldsValue({
          name: res.name,
          countryCode: number[0],
          number: number[1],
          email: res.email,
          position: res.position,
          relation: res.relation,
          time: res.relationDuration,
          title: res.title,
          institution: res.institutionName,
          address: res.institutionAddress,
        });
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    fetchData();
  }, []);

  useUnsavedChanges(!isFormDisabled);

  return (
    <Fragment>
      {element}
      <div className="referee-details-page">
        <Container>
          <CardComponent>
            <Row>
              <Col xxl={24}>
                <div className="heading">
                  <BackWithLabel label="Referee Details" path="/profile" />
                </div>
              </Col>
            </Row>

            <Form
              name="searchGuide"
              initialValues={{ remember: true }}
              layout="vertical"
              onFinish={handleFinish}
              form={form}
              requiredMark={customizeRequiredMark}
              {...formItemLayoutWithOutLabel}
            >
              <Row gutter={[16, 0]} className={isFormDisabled ? "" : "sideborder"}>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter referee name"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        // Check each character of the pasted data
                        if (![...pasteData].every((char) => /[A-Za-z\s]/.test(char))) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Position"
                    name="position"
                    className=""
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee position!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter referee position"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z0-9\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        if (/[^A-Za-z0-9\s]/.test(pasteData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Title"
                    name="title"
                    className=""
                    rules={[
                      {
                        required: true,
                        message: "Please enter referee’s title!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter referee’s title"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z0-9\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        if (/[^A-Za-z0-9\s]/.test(pasteData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Work Email"
                    name="email"
                    className=""
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Please enter referee’s email!",
                      },
                    ]}
                  >
                    <Input placeholder="Enter referee’s email" disabled={isFormDisabled} />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item label="Phone Number">
                    <Space.Compact style={{ width: "100%" }}>
                      <Form.Item name={"countryCode"} noStyle>
                        <Select
                          virtual={false}
                          placeholder="Select Contry"
                          defaultValue={"+91"}
                          showSearch
                          filterOption={keyFilterOption}
                          disabled={isFormDisabled}
                          style={{
                            maxWidth: "35%",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                          }}
                        >
                          {countryList.map((country) => {
                            return (
                              <Option
                                key={country.name}
                                value={country.phoneCode}
                                label={country.phoneCode}
                              >
                                <Flex justify="start" align="center" gap={"5px"}>
                                  <img src={country.flag} height={30} width={30} />
                                  {window.innerWidth > 425 ? (
                                    <span>{country.phoneCode}</span>
                                  ) : (
                                    <></>
                                  )}
                                </Flex>
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item
                        name="number"
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Please enter a valid WhatsApp registered number.",
                            pattern: new RegExp(/^([0-9]{7,14})$/),
                          },
                        ]}
                      >
                        <Input
                          type="number"
                          min={0}
                          minLength={7}
                          maxLength={14}
                          onWheel={(e) => e.currentTarget.blur()}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          style={{
                            width: "80%",
                          }}
                          disabled={isFormDisabled}
                          placeholder="Enter your mobile number"
                        />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>
                </Col>
              </Row>

              <Divider />

              <Row gutter={[16, 0]} justify="start" className={isFormDisabled ? "" : "sideborder"}>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item label="How long has the person known you?" name="time">
                    <Select
                      virtual={false}
                      placeholder="Enter your answer"
                      filterOption={filterOption}
                      disabled={isFormDisabled}
                    >
                      {["1 to 2 years", "2 to 4 years", "5+ years"].map((x) => {
                        return <Option key={x} value={x} label={x}></Option>;
                      })}
                    </Select>
                    {/* <Input
                      placeholder="Enter your answer"
                      disabled={isFormDisabled}
                    /> */}
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Relationship to you"
                    name="relation"
                    rules={[
                      {
                        required: true,
                        message: "Enter your relationship with referee!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Select a relationship with referee"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z0-9\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        if (/[^A-Za-z0-9\s]/.test(pasteData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {/* <Select
                virtual={false}
                      placeholder="Select a relationship with referee"
                      className="w-100"
                      // onChange={(value) => handleChange(value, "gender")}
                      // filterOption={filterOption}
                      disabled={isFormDisabled}
                    >
                      {relationshipOptions.map((relation) => {
                        return (
                          <Option
                            key={relation.value}
                            value={relation.value}
                            label={relation.label}
                          >
                            {relation.label}
                          </Option>
                        );
                      })}
                    </Select> */}
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Referee’s institution name"
                    name="institution"
                    className=""
                    rules={[
                      {
                        required: true,
                        message: "Enter referee’s institution name!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter referee’s institution name"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z0-9\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        if (/[^A-Za-z0-9\s]/.test(pasteData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label="Referee’s institution address"
                    name="address"
                    className=""
                    rules={[
                      {
                        required: true,
                        message: "Enter referee’s institution address!",
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter referee’s institution address"
                      disabled={isFormDisabled}
                      onKeyPress={(e) => {
                        const charCode = e.which || e.keyCode;
                        if (!/[A-Za-z0-9,()\-\s]/.test(String.fromCharCode(charCode))) {
                          e.preventDefault();
                        }
                      }}
                      onPaste={(e) => {
                        const pasteData = e.clipboardData.getData("text");
                        if (!/^[A-Za-z0-9,()\-\s]+$/.test(pasteData)) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row justify="center">
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  {isFormDisabled && (
                    <ButtonComponent
                      label="Edit Details"
                      varient="primary"
                      htmlType="button"
                      onClick={isFormDisabled ? () => setIsFormDisabled(false) : null}
                      className="w-100"
                    />
                  )}
                  {!isFormDisabled && (
                    <ButtonComponent
                      label="Save Changes"
                      varient="primary"
                      htmlType="submit"
                      className="w-100"
                    />
                  )}
                </Col>
              </Row>
            </Form>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default RefereeDetails;
